import { render, staticRenderFns } from "./InstagramReportDataTable.vue?vue&type=template&id=9c3cb878&scoped=true&"
import script from "./InstagramReportDataTable.vue?vue&type=script&lang=js&"
export * from "./InstagramReportDataTable.vue?vue&type=script&lang=js&"
import style0 from "./InstagramReportDataTable.vue?vue&type=style&index=0&id=9c3cb878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c3cb878",
  null
  
)

export default component.exports